import React from "react";
import "../scss/Panel.scss";
import "../scss/bootstrap-custom.scss";

function PanelSection(props) {
  const clickableTitle = typeof props.onClickTitle === "function";
  return (
    <div className={`PanelSection ${props.className || ""}`}>
      <div
        onClick={clickableTitle ? props.onClickTitle : undefined}
        className={`Panel${props.type || ""}Section_Title ${
          clickableTitle ? "clickable" : ""
        } ${props.title? "" : "NoTitle"}`}
      >
        {props.title}
      </div>
      <div
        className={`Panel${props.type || ""}Section_Body d-flex flex-column`}
      >
        {props.children}
      </div>
    </div>
  );
}

export default PanelSection;
